import { Component, Input } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { DialogMessageData } from 'sc-common/shared/dialog-message/dialog-message-data';

@Component(
    {
        selector: 'sc-dialog-message',
        templateUrl: './dialog-message.component.html',
        standalone: false
    })
export class DialogMessageComponent {

    @Input()
    public message: string;

    @Input()
    public messages: string[];

    constructor(dialogConfig: DynamicDialogConfig) {
        const data = dialogConfig.data as DialogMessageData;
        this.message = data.message;
        this.messages = data.messages;
    }
}
